import React from 'react';
import { Card } from '@components/atoms/Card';
import { WarningIcon } from './WarningIcon';
import { useTranslation } from '@hooks/useTranslation';

interface SuspendedOrganizationCardProps {
  children: React.ReactNode;
}

const SuspendedOrganizationCard: React.FC<SuspendedOrganizationCardProps> = ({
  children,
}) => {
  // Sprint 28, story-143. Bucket 2 — docs/architecture.md "## Sprint 28" Decision 4.
  const tOrgLifecycle = useTranslation('orgLifecycle');
  return (
    <Card className="max-w-lg w-full bg-white dark:bg-gray-800 rounded-xl shadow-lg p-8">
      <div className="flex flex-col items-center">
        <WarningIcon />

        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white mb-3 text-center">
          {tOrgLifecycle.organizationSuspendedTitle}
        </h1>

        <p className="text-gray-600 dark:text-gray-300 text-center mb-6">
          {tOrgLifecycle.organizationSuspendedMessage}
        </p>

        <div className="w-full">
          {children}
        </div>
      </div>
    </Card>
  );
};

export default SuspendedOrganizationCard;
